module.exports = __webpack_public_path__ + "static/media/move.94328846.png";